import { Button, SpacingToken } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'
import { navigate } from 'gatsby'

import { AMPLITUDE_EVENTS, EVENT_SOURCE_IDS } from '@/constants'
import useParamSelector from '@/hooks/useParamSelector'
import { addProduct } from '@/store/cart'
import { useTypedDispatch } from '@/store/hooks'
import {
  getItemById,
  hasProductInCart,
  isAddingProduct,
} from '@/store/selectors'
import { logAmplitudeEvent } from '@/store/stats'

const footerWrapperCss = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
`

interface IRequestBuyModalFooterProps {
  onClose: () => void
  id: string
}

const RequestBuyModalFooter = ({
  onClose,
  id,
}: IRequestBuyModalFooterProps) => {
  const dispatch = useTypedDispatch()
  const isInCart = useParamSelector(hasProductInCart, id)
  const isLoading = useParamSelector(isAddingProduct, id)
  const appName = useParamSelector(getItemById, id).name

  const handleAddToCart = () => {
    dispatch(
      addProduct.pending({
        productId: id,
        sourceId: EVENT_SOURCE_IDS.ONE_CLICK_PAYMENT,
      })
    )
    dispatch(
      logAmplitudeEvent({
        name: `${AMPLITUDE_EVENTS.ADD_TO_CART_CLICKED} - 1CP`,
        params: {
          appId: id,
          appName,
        },
      })
    )
  }

  const handleViewCart = () => {
    navigate('/cart')
  }

  return (
    <div css={footerWrapperCss}>
      <Button data-test="ocp-cancel-button" kind="secondary" onClick={onClose}>
        Cancel
      </Button>
      {isInCart ? (
        <Button
          data-test="ocp-view-cart-btn"
          kind="primary"
          onClick={handleViewCart}
        >
          View Cart
        </Button>
      ) : (
        <Button
          data-test="add-to-cart-btn"
          kind="primary"
          onClick={handleAddToCart}
          loading={isLoading}
        >
          Add to Cart
        </Button>
      )}
    </div>
  )
}

export default RequestBuyModalFooter
